// extracted by mini-css-extract-plugin
module.exports = {"HeaderPlusSub":"HeaderPlusSub_HeaderPlusSub__1UDVu"};